import { render, staticRenderFns } from "./AdministrativeStaff.vue?vue&type=template&id=509de164"
import script from "./AdministrativeStaff.vue?vue&type=script&lang=js"
export * from "./AdministrativeStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports